export default __webpack_public_path__ + "static/media/linkedin.1633a962.svg";